(() => {
  if (window.hyperxHeroShortSwipeReady) return;
  window.hyperxHeroShortSwipeReady = true;

  let gesture = null;

  const getSelectedIndex = (slider) => {
    const slides = Array.from(slider.querySelectorAll('.hdt-slider__slide'));
    return {
      index: slides.findIndex((slide) => slide.classList.contains('is-selected')),
      total: slides.length
    };
  };

  document.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary) return;

    const slider = event.target.closest('hdt-slideshow[data-hyperx-short-swipe]');
    if (!slider) return;

    const selected = getSelectedIndex(slider);
    if (selected.index < 0 || selected.total < 2) return;

    gesture = {
      pointerId: event.pointerId,
      slider,
      startX: event.clientX,
      startY: event.clientY,
      startIndex: selected.index,
      total: selected.total
    };
  }, true);

  document.addEventListener('pointerup', (event) => {
    if (!gesture || gesture.pointerId !== event.pointerId) return;

    const currentGesture = gesture;
    gesture = null;

    const deltaX = event.clientX - currentGesture.startX;
    const deltaY = event.clientY - currentGesture.startY;
    const threshold = Number(currentGesture.slider.dataset.hyperxShortSwipe) || 12;

    if (Math.abs(deltaX) < threshold || Math.abs(deltaX) <= Math.abs(deltaY)) return;

    requestAnimationFrame(() => {
      const selected = getSelectedIndex(currentGesture.slider);

      // Let the native HDT slider own normal and long drags. The bridge only
      // promotes a short horizontal drag when the native snap did not change.
      if (selected.index !== currentGesture.startIndex) return;

      const isRtl = document.documentElement.dir === 'rtl';
      const movesForward = isRtl ? deltaX > 0 : deltaX < 0;
      const offset = movesForward ? 1 : -1;
      const target = (currentGesture.startIndex + offset + currentGesture.total) % currentGesture.total;

      currentGesture.slider.goToIndex(target);
    });
  }, true);

  document.addEventListener('pointercancel', (event) => {
    if (gesture?.pointerId === event.pointerId) gesture = null;
  }, true);
})();
